import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UseVideoContext } from "../Components/Contexts/VideoContext";

/**
 * Custom hook to handle category validation and conversion to IDs
 * @param {string} categoriesString - Categories separated by "+" (e.g., "action+drama")
 * @returns {Array} Array of category IDs or null if no valid categories found
 */
export function useCategories(categoriesString) {
  const { loadedCategories } = UseVideoContext();
  const navigate = useNavigate();
  const { days, sort } = useParams();

  return useMemo(() => {
    // Validate categories and redirect if invalid
    if (loadedCategories?.length > 0) {
      const validCategories = categoriesString?.split("+") ?? ["all"];
      for (let category of validCategories) {
        if (category === "all") break;
        if (!loadedCategories.some((cat) => cat.slug === category)) {
          navigate(`/videos/all/${days}/${sort}${window.location.search}`, {
            replace: true,
          });
          return null;
        }
      }
    }

    // Convert category slugs to IDs
    const validCategories = categoriesString?.split("+") ?? ["all"];
    const categoryIds = [];

    if (loadedCategories != null) {
      for (let cat of validCategories) {
        let foundCat = loadedCategories.find(
          (c) => c.slug.toLowerCase() === cat.toLowerCase()
        );
        if (foundCat != null) {
          categoryIds.push(foundCat.id);
        }
      }
    }

    return categoryIds.length > 0 ? categoryIds : null;
  }, [categoriesString, loadedCategories, navigate, days, sort]);
}

export default useCategories;
